$(document).ready(function() {



    function hideProductImages(){
        var elements = document.querySelectorAll('.cropper_t');
        elements.forEach(function(element) {
            element.style.cssText = 'display: none !important;';
        });
    }

    function showProductImages(){
        var elements = document.querySelectorAll('.cropper_t');
        elements.forEach(function(element) {
            element.removeAttribute("style");
        });
    }

    $(".messure_info").click(function() {
        $(".info_first").toggle()
    });

    $('.paper-type').hide();
    var paperType = $('.action-set.selected-variant').data('paper-type');
    let modifiedVariant = paperType.toLowerCase().replace(/\s+/g, '-');
    $(`.paper__${modifiedVariant}`).show();


    var current_action = "cm";
    $(".custom-size-action-radio").change(function() {
        var $this = $(this);
        if ($(".mesure").hide(),
            $(".mesure :input").attr("disabled", "disabled"),
            destroycroper(),
            $this.is(":checked"))
            if (current_action = $this.val(),
            current_action == "inches")
                $(".inc_container").show(),
                    $(".inc_container :input").removeAttr("disabled");
            else if (current_action == "ft")
                $(".inc_ft_container").show(),
                    $(".inc_ft_container :input").removeAttr("disabled");
            else if (current_action == "cm")
                $(".cm_container").show(),
                    $(".cm_container :input").removeAttr("disabled");
            else
                return alert("Invalid action"),
                    !1
    });
    var is_init = !1
        , image_ratio = 1
        , height_set = 500
        , width_set = 500
        , original_image_customer = ""
        , resolution = ""
        , width_render = ""
        , height_render = ""
        , width_pass = ""
        , height_pass = ""
        , quantity = ""
        , cropper = "";
    setPriceFirstVariantInit();
    function getPrice() {
        return $(".base_price").attr("data-price")
    }
    function setPriceInit() {
        var price = $(".base_price").attr("data-price");
        price = parseInt(price / 100) + "." + price % 100,
            $(".base_price").attr("data-price", price)
    }
    function setPriceFirstVariantInit() {
        var price = $(".base_price").attr("data-price");
        price = parseInt(price / 100) + "." + price % 100,
            $(".base_price").attr("data-price", price),
            $("#prd_price").text(price),
            $(".price-item").html("&#163;" + price)
    }
    function setPrice(price) {
        var final = price
            , final = String(final).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        $("#prd_price").text(final),
            $(".m_s").hide()
    }
    function filter_price(price) {
        return parseInt(price / 100) + "." + price % 100
    }
    $(".action-set").on("click", function() {
        var $this = $(this);
        $(".action-set").removeClass("selected-variant"),
            $this.addClass("selected-variant");
        let selected_variant = $this.data("paper-type");
        let modifiedVariant = selected_variant.toLowerCase().replace(/\s+/g, '-');
        $('.paper-type').hide();
        $(`.paper__${modifiedVariant}`).show();

        const inputElement = $(".variant-picker__option-values input[value='" + selected_variant + "']");
        if (inputElement.length > 0) {
            inputElement.click();
        }

        var price = $this.attr("data-price");
        price = parseInt(price / 100) + "." + price % 100,
            $(".base_price").attr("data-price", price),
            $(".price-item").html("&#163;" + price);
        var size_price = $(".sizes-container").attr("data-price");
        size_price != "" && (price = parseFloat(size_price) * parseFloat(price),
            price = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,")),
            $("#prd_price").text(price)
    });
    function destroycroper() {
        var price = $(".selected-variant").attr("data-price");
        price = parseInt(price / 100) + "." + price % 100,
            price = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,"),
            $(".base_price").attr("data-price", price),
            $(".sizes-container").attr("data-price", ""),
            $("#prd_price").text(price),
            $(".croper_main_image").hide(),
            showProductImages(),
        is_init && cropper.destroy(),
            $(".inputsize").val("")
    }
    $("body").on("paste keyup input", ".inputsize", function() {
        if (current_action == "inches")
            if ($(".in_width").val() > 0 && $(".in_height").val() > 0) {
                width_render = $(".in_width").val() + "inches",
                    height_render = $(".in_height").val() + "inches",
                    quantity = convert_into($(".in_width").val(), $(".in_height").val(), "inches"),
                    $(".sizes-container").attr("data-price", quantity);
                var result_out = quantity * getPrice();
                setPrice(result_out),
                    image_ratio = $(".in_width").val() / $(".in_height").val(),
                    init_cropper()
            } else
                return is_init && cropper.destroy(),
                    $(".croper_main_image").hide(),
                    showProductImages(),
                    !1;
        else if (current_action == "ft")
            if (parseInt($(".inf_width").val()) > 10 && $(".inf_width").val(11),
            parseInt($(".inf_height").val()) > 10 && $(".inf_height").val(11),
            parseInt($(".ft_width").val()) > 0 && parseInt($(".ft_height").val()) > 0) {
                var inc_w = $(".inf_width").val()
                    , inc_h = $(".inf_height").val()
                    , c_in_width = $(".inf_width").val()
                    , c_in_height = $(".inf_height").val()
                    , c_ft_width = $(".ft_width").val()
                    , c_ft_height = $(".ft_height").val()
                    , c_complete_width = parseFloat(c_ft_width) + parseFloat(c_in_width / 12);
                c_complete_width = c_complete_width.toFixed(4);
                var c_complete_height = parseFloat(c_ft_height) + parseFloat(c_in_height / 12);
                c_complete_height = c_complete_height.toFixed(4);
                var cal_in_width = $(".inf_width").val()
                    , cal_in_height = $(".inf_height").val()
                    , cal_ft_width = $(".ft_width").val()
                    , cal_ft_height = $(".ft_height").val();
                if (inc_w == "" && (cal_in_width = 0),
                inc_h == "" && (cal_in_height = 0),
                inc_w == "" && (inc_w = 0),
                inc_h == "" && (inc_h = 0),
                    inc_w > 10 ? (c_width = 1,
                        c_complete_width = parseInt(c_ft_width) + 1,
                        inc_w = 0,
                        c_ft_width = parseInt(c_ft_width) + 1,
                        cal_ft_width = parseInt(c_ft_width) + 1,
                        cal_in_width = 0) : inc_w > 0 && inc_w < 10,
                inc_h > 10) {
                    var height_inc = convert_into(1, "feet");
                    c_complete_height = parseInt(c_ft_height) + 1,
                        c_ft_height = parseInt(c_ft_height) + 1,
                        inc_h = 0,
                        cal_ft_height = parseInt(cal_ft_height) + 1,
                        cal_in_height = 0
                } else
                    inc_h > 0 && inc_h < 10;
                width_render = $(".ft_width").val() + "ft_" + inc_w + "in",
                    height_render = $(".ft_height").val() + "ft_" + inc_h + "in";
                var width_c = parseInt(cal_ft_width) * 30.48 + parseInt(cal_in_width) * 2.54
                    , height_c = parseInt(cal_ft_height) * 30.48 + parseInt(cal_in_height) * 2.54;
                quantity = convert_into(width_c.toFixed(2), height_c.toFixed(2), "unitfeet"),
                    $(".sizes-container").attr("data-price", quantity);
                var result_out = quantity * getPrice();
                setPrice(result_out),
                    image_ratio = c_complete_width / c_complete_height,
                    init_cropper()
            } else
                return is_init && cropper.destroy(),
                    $(".croper_main_image").hide(),
                    showProductImages(),
                    !1;
        else if (current_action == "cm")
            if ($(".cm_width").val() > 0 && $(".cm_height").val() > 0) {
                var width2 = convert_into($(".cm_width").val(), "cm")
                    , height2 = convert_into($(".cm_height").val(), "cm");
                width_render = $(".cm_width").val() + "cm",
                    height_render = $(".cm_height").val() + "cm",
                    quantity = convert_into($(".cm_width").val(), $(".cm_height").val(), "cm"),
                    $(".sizes-container").attr("data-price", quantity);
                var result_out = quantity * getPrice();
                setPrice(result_out),
                    image_ratio = $(".cm_width").val() / $(".cm_height").val(),
                    init_cropper()
            } else
                return is_init && cropper.destroy(),
                    $(".croper_main_image").hide(),
                    showProductImages(),
                    !1
    });
    function convert_into(w, h, type) {
        if (type == "cm")
            return Math.ceil(w * h / 1e4);
        if (type == "inches")
            return width = w * 2.54,
                height = h * 2.54,
                Math.ceil(width * height / 1e4);
        if (type == "unitfeet")
            return Math.ceil(w * h / 1e4)
    }
    function init_cropper() {
        hideProductImages(),
            $(".croper_main_image").show(),
        is_init && cropper.destroy(),
            is_init = !0;
        var image = document.getElementById("crop_image_main")
            , save = document.getElementById("save")
            , original_image_customer2 = image.src;
        image.style.visibility = "visible",
            cropper = new Cropper(image,{
                aspectRatio: image_ratio,
                viewMode: 1,
                center: !1,
                zoomable: !1,
                checkCrossOrigin: !0,
                checkOrientation: !1,
                dragMode: "none",
                autoCropArea: 1,
                rotatable: !0,
                cropBoxResizable: 1,
                scalable: !0,
                movable: !1,
                ready: function() {
                    croppable = !0
                }
            })
    }

    function uploadImage(base64Image) {
        $('.m-spinner-icon').css('display', 'flex');
        $('.animate-spin').css('display', 'flex');
        $('.m-add-to-cart--text').css('visibility', 'hidden');
        console.log(typeof base64Image)
        var inputData = {
            image_base64: base64Image
        };

        fetch("https://artforprinting.com/ok.php", {
            method: "POST",
            body: JSON.stringify(inputData)
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error("Error: " + response.status + " - " + response.statusText);
                }
            })
            .then(data => {
                $("#CropPath").val(data.image_url),
                    $(".m-quantity__input").val(quantity),
                    $(".inputsize").val(""),
                    $("#mirror_set").prop("checked", !1),
                    $("button[name='add']").click(),
                    $('.m-spinner-icon').css('display', 'none'),
                    $('.animate-spin').css('display', 'none'),
                    $('.m-add-to-cart--text').css('visibility', 'visible')
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }




    $("#mirror_set").change(function() {
        $(this).is(":checked") ? cropper.scale(-1, 1) : cropper.scale(1)
    }),
        $("body").on("click", ".cst_crop_buy", function() {
            var selected_variant = $(".selected-variant").attr("data-id");
            if (selected_variant = parseInt(selected_variant),
            cropper == "" || quantity == "")
                return alert("Invalid Input"),
                    !1;
            var crop_image = cropper.getCroppedCanvas({
                height: height_set,
                width: width_set
            }).toDataURL("image/png")
                , size_width_value = width_render
                , size_height_value = height_render;
            $("[data-selected-variant]").val(selected_variant),
                $("#SizeCustom").val(size_width_value + "  x " + size_height_value + " "),
                uploadImage(crop_image)
        })
});